var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-header" },
      [
        _c("h1", { staticClass: "page-title" }, [_vm._v("VSM Users")]),
        _c("breadcrumb", { attrs: { name: "VSM_USER_MANAGEMENT_LIST" } }),
        _c("div", { staticClass: "page-header-left" }, [
          _c("div", { staticClass: "mt-4" }, [
            _c("div", { staticClass: "row mb-4" }, [
              _c("div", { staticClass: "col-6" }, [
                _c("div", { staticClass: "d-flex g-1" }, [
                  _c("label", { staticClass: "col-form-label w-120" }, [
                    _vm._v("Role"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.role,
                        expression: "role",
                      },
                    ],
                    staticClass: "form-control w-250",
                    attrs: { placeholder: "All" },
                    domProps: { value: _vm.role },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.role = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _c("div", { staticClass: "d-flex g-1" }, [
                  _c("label", { staticClass: "col-form-label w-120" }, [
                    _vm._v("VSM Username"),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.username,
                        expression: "username",
                      },
                    ],
                    staticClass: "form-control w-250",
                    attrs: { placeholder: "All" },
                    domProps: { value: _vm.username },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.username = $event.target.value
                      },
                    },
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-round btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.search },
                    },
                    [_vm._v(" Search ")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "page-header-right" },
          [_c("VSMUserBulkAdd", { on: { done: _vm.onDone } })],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "page-content page-content-table" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "panel" }, [
          _c(
            "div",
            { staticClass: "panel-body p-0" },
            [
              _c(
                "vue-good-table",
                {
                  ref: "table",
                  attrs: {
                    mode: "remote",
                    columns: _vm.columns,
                    rows: _vm.list,
                    totalRows: _vm.totalRecords,
                    "sort-options": {
                      enabled: true,
                      initialSortBy: { field: "vsm_id" },
                    },
                    "pagination-options": _vm.pagination,
                    "search-options": Object.assign({}, _vm.searchOption, {
                      trigger: "enter",
                    }),
                  },
                  on: {
                    "on-sort-change": _vm.onSortChange,
                    "on-page-change": _vm.onPageChange,
                    "on-search": _vm.onSearch,
                    "on-row-dblclick": _vm.onRowDoubleClick,
                    "on-per-page-change": _vm.onPerPageChange,
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "table-actions" }, slot: "table-actions" },
                    [
                      _c("div", { staticClass: "Excel" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            on: { click: _vm.exportToExcel },
                          },
                          [
                            _c("i", { staticClass: "fa fa-file-excel-o" }),
                            _vm._v(" Export to Excel "),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }